D.store = {
  COOKIE_PREFIX: 'rgsto_',
  _useLocalStorage: null,
  useLocalStorage: function () {
    if (this._useLocalStorage === null) {
      try {
        if (window.localStorage) {
          localStorage.setItem('test', '1');
          this._useLocalStorage = true;
        } else {
          this._useLocalStorage = false;
        }
      } catch (e) {
        this._useLocalStorage = false;
      }
    }
    return this._useLocalStorage;
  },
  setItem: function (key, value) {
    if (this.useLocalStorage()) {
      localStorage.setItem(key, value);
    } else {
      D.Cookie.create(this.COOKIE_PREFIX + key, value);
    }
  },
  getItem: function (key) {
    if (this.useLocalStorage()) {
      return localStorage.getItem(key);
    } else {
      return D.Cookie.read(this.COOKIE_PREFIX + key);
    }
  },
  clear: function (key) {
    if (this.useLocalStorage()) {
      localStorage.removeItem(key);
    } else {
      D.Cookie.erase(this.COOKIE_PREFIX + key);
    }
  }
};